.presence {
  &:not(:first-child) {
    position: absolute;
    top: 0;
    width: 100%;
  }
}
